import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/udi-logo.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "notificacion-header" }
const _hoisted_4 = { class: "contenido" }
const _hoisted_5 = { class: "descripcion" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "notificacion-acciones"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "sin-notificaciones"
}

import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useModelo } from '@/store/GestionModelo'
import { useGestionVersiones } from '@/store/GestionVersiones'
import type EstructuraModelo from '@/interfaces/EstructuraModelo'
import type Version from '@/interfaces/Versiones'

interface ModeloConVersiones extends EstructuraModelo {
  versions: Version[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CardNotificación',
  setup(__props) {

/**
 * Tarjeta de notificación individual.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const router = useRouter()
const modeloStore = useModelo()
const versionesStore = useGestionVersiones()
const modelos = ref<ModeloConVersiones[]>([])

// IDs de versiones ocultas solo en la UI
const ocultos = ref<Set<number>>(new Set())
const expandido = ref<number | null>(null)

// Normaliza estado quitando tildes y pasando a minúsculas
function normalizarEstado(estado?: string): string {
  return (estado ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim()
}

// Versiones de modelos en edición (estructura aún no aprobada), ordenadas por fecha
// Se filtra por estado del MODELO, no de la versión, porque tras aprobar el modelo
// la versión queda en edicion pero la notificación ya no debe aparecer
const filtrados = computed<Version[]>(() =>
  modelos.value
    .filter(m => normalizarEstado(m.estado) === 'edicion')
    .flatMap(m => (m.versions ?? []))
    .filter(v => v.id_version != null && !ocultos.value.has(v.id_version!))
    .sort((a, b) => parseFecha(b.fecha_creacion) - parseFecha(a.fecha_creacion))
)

// Solo mostramos máximo 6
const visibles = computed<Version[]>(() =>
  filtrados.value.slice(0, 6)
)

onMounted(async () => {
  modelos.value = await modeloStore.getModelo() as ModeloConVersiones[]
})

function dismiss(id?: number) {
  if (typeof id === 'number') {
    ocultos.value.add(id)
    if (expandido.value === id) expandido.value = null
  }
}

function toggleExpand(id: number) {
  expandido.value = expandido.value === id ? null : id
}

function accederVersion(v: Version) {
  if (!v.id_modelo || !v.id_version) return
  router.push({ name: 'EstructuraModelo', params: { id_modelo: v.id_modelo, id_version: v.id_version } })
}

const formatterFecha = new Intl.DateTimeFormat('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' })

function parseFecha(fecha: string): number {
  const soloFecha = fecha.substring(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(soloFecha)) {
    const [yyyy, mm, dd] = soloFecha.split('-').map(Number)
    return new Date(yyyy, mm - 1, dd).getTime()
  }
  const t = new Date(fecha).getTime()
  return isNaN(t) ? 0 : t
}

function formatFecha(fecha?: string | null) {
  if (!fecha) return '-'
  const soloFecha = fecha.substring(0, 10)
  if (/^\d{4}-\d{2}-\d{2}$/.test(soloFecha)) {
    const [yyyy, mm, dd] = soloFecha.split('-').map(Number)
    const d = new Date(yyyy, mm - 1, dd)
    return formatterFecha.format(d)
  }
  const d = new Date(fecha)
  return isNaN(d.getTime()) ? fecha : formatterFecha.format(d)
}

return (_ctx: any,_cache: any) => {
  return (visibles.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (v) => {
          return (_openBlock(), _createElementBlock("div", {
            key: v.id_version,
            class: "notificacion-card notificacion-clickable",
            onClick: ($event: any) => (toggleExpand(v.id_version!))
          }, [
            _createElementVNode("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "img-modelo" }, [
                _createElementVNode("img", {
                  src: _imports_0,
                  alt: "udi-logo",
                  class: "logo"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", {
                  class: _normalizeClass(['titulo', expandido.value === v.id_version ? 'titulo-expandido' : ''])
                }, _toDisplayString(v.nombre), 3),
                _createElementVNode("p", _hoisted_5, _toDisplayString(formatFecha(v.fecha_creacion)), 1)
              ]),
              _createElementVNode("button", {
                class: "cerrar",
                "aria-label": "Cerrar notificación",
                onClick: _withModifiers(($event: any) => (dismiss(v.id_version)), ["stop"])
              }, " ✕ ", 8, _hoisted_6)
            ]),
            (expandido.value === v.id_version)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "btn-acceder",
                    onClick: _withModifiers(($event: any) => (accederVersion(v)), ["stop"])
                  }, "Acceder", 8, _hoisted_8)
                ]))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_9, " No hay notificaciones. "))
}
}

})